import { AppVersion } from '@interfaces/version';
import useSWR from 'swr';
import { getData, ValidationErrorResponse } from '@apis/rest-client';

export const useGetWebAPIVersion = () => {
    return useSWR<AppVersion, ValidationErrorResponse>('AppVersion', getData);
};

export const useGetReportServiceVersion = () => {
    return useSWR<AppVersion, ValidationErrorResponse>('ReportTemplates/AppVersion', getData);
};

export const useGetCentralMonitoringServiceVersion = () => {
    return useSWR<AppVersion, ValidationErrorResponse>('CentralMonitoring/AppVersion', getData);
};

export const useGetIntegrationsServiceVersion = () => {
    return useSWR<AppVersion, ValidationErrorResponse>('Integrations/AppVersion', getData);
};
